module.exports = __webpack_public_path__ + "07ec7ccbea282d9458ad56ee5df564bf.svg";